define('modules/common/controller/Fascicolo',[], function() {
    var Controller = function(
        $scope,
        $stateParams,
        DettagliFascicolo,
        DocumentiFascicolo,
        $state,
        ListaFascicoli,
        $modal,
        InvioMail,
        LoadingHandler) {

        $scope.busy = true;


        $scope.hrefFascicolo = $stateParams.hrefFascicolo;


        DettagliFascicolo.load($scope.hrefFascicologlobal).then(function(dati) {
            $scope.datiFascicolo = dati;
            

            $scope.checkedEmail = !!($scope.datiFascicolo.emailavvocato && $scope.datiFascicolo.emailcliente);
            DocumentiFascicolo.count($scope.datiFascicolo.hrefdocumenti)
                .then(function(count) {
                    $scope.numDocumenti = count;
                    $scope.busy = false;
                }, function() {
                    $scope.busy = false;
                });

            $scope.datiFascicolo.hrefdocumenti = $scope.datiFascicolo.hrefdocumenti.split('/').join('___');

        });



        $scope.apriModaleContatti = function() {
            $scope.erroreInvio = false;
            $modal.open({
                animation: true,
                resolve: {
                    fascicolohref: function() {
                        return $scope.hrefFascicologlobal;
                    }
                },
                templateUrl: 'modules/common/view/modalTestoMail.tpl.html',
                controller: 'ModalTestoMailController',
                size: "lg"
            }).result.then(function(messaggio) {
                LoadingHandler.start();
                InvioMail(messaggio).then(function() {
                    console.log("email inviata");
                }).catch(function(errore) {
                    $scope.erroreInvio = true;
                })['finally'](function() {
                    LoadingHandler.stop();
                });
            });
        };

        $scope.apriModaleNote = function() {
            $modal.open({
                animation: true,
                resolve: {
                    testoNota: function() {
                        return $scope.datiFascicolo.notepercliente;
                    }
                },
                templateUrl: 'modules/common/view/modalNote.tpl.html',
                controller: 'ModalNoteController',
                size: "lg"
            });
        };


        $scope.goBack = function() {

            var params = {
                aliasStudio: $scope.aliasStudio
            };

            if (ListaFascicoli.getQuery()) {
                params.query = ListaFascicoli.getQuery();
            }

            $state.go('fascicoli', params);
        };

    };

    return [
        "$scope",
        "$stateParams",
        "DettagliFascicolo",
        "DocumentiFascicolo",
        "$state",
        "ListaFascicoli",
        "$modal",
        "InvioMail",
        "LoadingHandler",
        Controller
    ];
});
